const DEFAULT_COURIER_API_BASE_URL = '/api';
const DEFAULT_APPLICANT_V2_API_BASE_URL = 'https://c7ge2tmp2m.execute-api.us-east-1.amazonaws.com/dev';
const DEFAULT_DRIVER_LOGIN_URL = 'https://drivers.valleyeats.ca';
const DEFAULT_PRODUCTION_APPLICANT_BASE_PATH = '/applicants';

const normalizeBasePath = (basePath: string | undefined) => {
  const trimmed = (basePath || '').trim();
  if (!trimmed || trimmed === '/') return '';

  try {
    const parsed = new URL(trimmed);
    return parsed.pathname.replace(/\/+$/, '') || '';
  } catch {
    const withLeadingSlash = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return withLeadingSlash.replace(/\/+$/, '');
  }
};

const configuredCourierApiBaseUrl =
  process.env.REACT_APP_COURIER_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  DEFAULT_COURIER_API_BASE_URL;
const configuredApplicantBasePath =
  process.env.REACT_APP_APPLICANT_BASE_PATH ||
  process.env.PUBLIC_URL ||
  (process.env.NODE_ENV === 'production' ? DEFAULT_PRODUCTION_APPLICANT_BASE_PATH : '');

export const COURIER_API_BASE_URL = configuredCourierApiBaseUrl.replace(/\/+$/, '');
export const APPLICANT_V2_API_BASE_URL = (
  process.env.REACT_APP_APPLICANT_V2_API_BASE_URL || DEFAULT_APPLICANT_V2_API_BASE_URL
).replace(/\/+$/, '');
export const COURIER_API_ROOT_URL = COURIER_API_BASE_URL.endsWith('/api')
  ? COURIER_API_BASE_URL.slice(0, -4)
  : COURIER_API_BASE_URL;
export const DRIVER_LOGIN_URL = (process.env.REACT_APP_DRIVER_LOGIN_URL || DEFAULT_DRIVER_LOGIN_URL).replace(/\/+$/, '');
export const APPLICANT_BASE_PATH = normalizeBasePath(configuredApplicantBasePath);

export const courierApiUrl = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${COURIER_API_BASE_URL}${normalizedPath}`;
};

export const applicantV2ApiUrl = (path: string) => {
  if (!path || path === '/') return `${APPLICANT_V2_API_BASE_URL}/v2/applications`;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${APPLICANT_V2_API_BASE_URL}/v2/applications${normalizedPath}`;
};

export const withApplicantBasePath = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (!APPLICANT_BASE_PATH) return normalizedPath;
  if (normalizedPath === '/') return APPLICANT_BASE_PATH;
  return `${APPLICANT_BASE_PATH}${normalizedPath}`;
};
